import { render, staticRenderFns } from "./deleteActivitiesType.vue?vue&type=template&id=117f0d96&scoped=true"
import script from "./deleteActivitiesType.vue?vue&type=script&lang=js"
export * from "./deleteActivitiesType.vue?vue&type=script&lang=js"
import style0 from "./deleteActivitiesType.vue?vue&type=style&index=0&id=117f0d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117f0d96",
  null
  
)

export default component.exports